import { render, staticRenderFns } from "./ExportOpticalgymPackage.vue?vue&type=template&id=368f36a8&scoped=true"
import script from "./ExportOpticalgymPackage.vue?vue&type=script&lang=js"
export * from "./ExportOpticalgymPackage.vue?vue&type=script&lang=js"
import style0 from "./ExportOpticalgymPackage.vue?vue&type=style&index=0&id=368f36a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f36a8",
  null
  
)

export default component.exports